module.exports = __webpack_public_path__ + "img/tp-card.471658cf.png";